import React from "react";
import UserGuideContent from "../../../components/AdminCentral/UserGuide/UseGuideContent";

export default function UserGuidePage({ colors }) {
  return <UserGuideContent colors={colors} />;
}
